/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AnnouncementsWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1ElEQVR4nNWUv0scURDH10RJSKGmSBH9A7SwECUpQszFyjW782OFtzN3FgcJHIikSRNIc00KsRD/APU/MFXSBYRAhKQS/wLB0p9gY2KhzO3euXcYWS53hQMDO2/nfT/z3pv3PO8uWKFQ6AWWL0i66Zy733EARrqIrJfmwLLQUfEgKD1GlgNg3TC3b6LyYMcAQLpqlQeBG0bUoXQVK22JFcrlh4jxdD0O54qjQPLXRMMofsZcfF4D2Bi6kVyi1Wr1HpG8RtY1YDmxLfB9/0GtepZvjb0n+YWkvzPx11uFgygeA9JlINmvT0om6vta9Syz2XEieRFy8WXzWDzTECQqvjExID1K9jZZOra4HWpa/W523MSJZKopn3SnAchWavFN4sh66ZwbSAC69a+cjH9vALI/bgMgywevHcsLANI/QPLRd+5JVwCYw+vn2DUAphpNlveQsV2A9XXSpnLYFUCrXfey7HUV4HleD2L8CkjWOw04t0Tfn++vxahR2iFn6SW7+C8AsP5It2gbWauZJnhr/6No/imQfALS07YARKVxezmb+pv1Z6VS6cvmMZcmkeW4BXDu5TF7d4ClgqxLQPIuDMNHN+WFUTxhK7UHMrnp+jkX4E7YFWys+5OLzcf/AAAAAElFTkSuQmCC)
 */
export const AnnouncementsWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 1.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.92 1.92 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12.43 5.7a.5.5 0 0 1 .6.72l-.63 1.1c-1.22 2.13.46 4.48 2.64 4.48h6.46c.28 0 .5.22.5.5v8c0 .83-.67 1.5-1.5 1.5h-.94a3 3 0 0 1-2.46-1.28 3.85 3.85 0 0 0-1.07-1.03l-2.36-.94a.92.92 0 0 0-1.23.63 2.92 2.92 0 0 1-3.55 2.12l-.62-.15A3 3 0 0 1 6 18.44V8.35c0-.2.13-.4.33-.47l6.1-2.18Zm-1.4 12.1L8 16.7v1.73a1 1 0 0 0 .76.97l.62.15c.5.13 1-.17 1.12-.67.1-.41.29-.78.53-1.1Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 10c0-1.1.9-2 2-2h.5c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5H4a2 2 0 0 1-2-2v-4Z"
        className={colorClass}
      />
    </svg>
  );
};
